export default class MissingSlugVariableError extends Error {
};
